var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3379_5877)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7064 15.7064C12.5188 15.8938 12.2645 15.9992 11.9994 15.9992C11.7342 15.9992 11.4799 15.8938 11.2924 15.7064L5.63537 10.0494C5.53986 9.95712 5.46367 9.84678 5.41126 9.72477C5.35886 9.60277 5.33127 9.47155 5.33012 9.33877C5.32896 9.20599 5.35426 9.07431 5.40454 8.95141C5.45483 8.82852 5.52908 8.71686 5.62297 8.62297C5.71686 8.52908 5.82852 8.45483 5.95141 8.40454C6.07431 8.35426 6.20599 8.32896 6.33877 8.33012C6.47155 8.33127 6.60277 8.35886 6.72477 8.41126C6.84677 8.46367 6.95712 8.53986 7.04937 8.63537L11.9994 13.5854L16.9494 8.63537C17.138 8.45321 17.3906 8.35241 17.6528 8.35469C17.915 8.35697 18.1658 8.46214 18.3512 8.64755C18.5366 8.83296 18.6418 9.08377 18.644 9.34597C18.6463 9.60816 18.5455 9.86076 18.3634 10.0494L12.7064 15.7064Z",
    fill: "#0CAF6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3379_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.81f7f311ec1614b27872e9b45e1c442e.svg";
export { ForwardRef as ReactComponent };